import React, { Component } from 'react'
import update from 'react/lib/update';
import PropTypes from 'prop-types'
import Radium from 'radium';
import Row from './table/row'
import Cell from './table/cell'
import Header from './table/header'
import { semanticColors } from '../../../../Globals/styles';

const propTypes = {}

const defaultProps = {}

class Crew extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: [
                '5%',
                '35%',
                '10%',
                '20%',
                '10%',
                '10%',
                '10%',
            ],
        }
    }
    shouldComponentUpdate(nextProps) {
        if (this.props.crewKey === nextProps.crewKey) { return false }
        return true
    }
    renderHeader = () => {
        return (
            <Row
            >
                <Header
                    content={'Pos.'}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Funktion'}
                    style={{ width: this.state.width[1] }}
                />
                <Header
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    style={{ width: this.state.width[3] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Timer'}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Pris'}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Sum'}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        textAlign: 'right',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }
    round15up = (x) => {
        return Math.round(x / 15) * 15;
    }
    filterOnlyDigits = (s) => {
        return s.replace(/[^0-9.,:]/g, "")
    }
    rounxs = (x) => {
        x = x.replace('.', '')
        var end_minutes = x.slice(-2);
        var end_hour = x.slice(0, -2);
        var minutes = this.round15up(end_minutes)
        // eslint-disable-next-line
        if (minutes == 0) minutes = '00'
        // eslint-disable-next-line
        else if (minutes >= 60) {
            minutes = '00'
            end_hour = parseInt(end_hour, 10) + 1
            if (end_hour < 10) {
                end_hour = '0' + end_hour
            }
            end_hour = end_hour + ':'
        }
        if (parseInt(end_hour) >= 24) { end_hour = '00:' }
        return end_hour + minutes
    }

    updateMarkers = (index, value, row) => {
        let nvalue = value
        let inputAsArray = value.split(':')
        if (inputAsArray.length === 2 && (inputAsArray[0].length === 2 && inputAsArray[1].length === 2)) {
            nvalue = this.rounxs(this.filterOnlyDigits(value))
        }
        row.markers[index] = nvalue
        this.props.update(row.function, row)
    }

    updateFunction = (key, value, obj) => {
        if (key === 'price') {
            obj.sum = (parseFloat(obj.pool.toString().replace(',', '.')) * parseFloat(value.replace(',', '.'))).toFixed(2).toString().replace('.00', '').replace('.', ',')
        } else if (key === 'pool') {
            obj.sum = (parseFloat(value.replace(',', '.')) * parseFloat(obj.price.toString().replace(',', '.'))).toFixed(2).toString().replace('.00', '').replace('.', ',')
        }
        obj[key] = value
        this.props.update(obj.function, obj)
    }
    updateChildFunction = (key, value, obj, row, index) => {
        obj[key] = value
        row.details[index] = obj

        let total = 0
        let hours = 0
        row.details.forEach((spec) => {
            total += parseFloat(spec.price.toString().replace(',', '.')) * parseFloat(spec.hours.toString().replace(',', '.'))
            hours += parseFloat(spec.hours.toString().replace(',', '.'))
        })

        row.pool = hours.toString().length > 2 ? hours.toFixed(2) : hours
        row.sum = total.toFixed(2).toString().replace('.00', '').replace('.', ',')
        this.props.update(row.function, row)
    }

    parseAndCalcSum(one, two) {
        return (parseFloat(one.toString().replace(',', '.')) * parseFloat(two.toString().replace(',', '.')))
    }
    renderContent = (r, index) => {
        let background = index % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
        return (
            <Row
                key={r.function}
            >
                <Cell
                    onChange={(value) => this.updateFunction('pos', value, r)}
                    content={r.pos}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        fontWeight: 600,
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('functionDisplay', value, r)}
                    content={r.functionDisplay}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        fontWeight: 600,
                        backgroundColor: background
                    }}
                />
                <Cell
                    onClick={() => this.updateFunction('unfolded', (r.unfolded ? !r.unfolded : true), r)}
                    inputClassName="fa"
                    content={r.function !== 'pause' && !this.props.open ? (r.unfolded ? "\uf0d8" : "\uf0d7") : ''}
                    readOnly
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                        ':hover': {
                            cursor: 'pointer'
                        }
                    }}
                />
                <Cell
                    onClick={() => this.updateFunction('unfolded', (r.unfolded ? !r.unfolded : true), r)}
                    inputClassName="fa"
                    content={r.function !== 'pause' && !this.props.open ? (r.unfolded ? "\uf0d8" : "\uf0d7") : ''}
                    readOnly
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                        ':hover': {
                            cursor: 'pointer'
                        }
                    }}
                />
                <Cell
                    onClick={() => this.updateFunction('unfolded', (r.unfolded ? !r.unfolded : true), r)}
                    onChange={(value) => this.updateFunction('pool', value, r)}
                    readOnly={r.function !== 'pause'}
                    content={r.pool.toString().replace('.', ',')}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                        fontWeight: 600,
                    }}
                />
                <Cell
                    onClick={() => this.updateFunction('unfolded', (r.unfolded ? !r.unfolded : true), r)}
                    onChange={(value) => this.updateFunction('price', value, r)}
                    readOnly={r.function !== 'pause'}
                    content={r.price.toString().replace('.00', '').replace('.', ',')}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                        fontWeight: 600,
                    }}
                />
                <Cell
                    onClick={() => this.updateFunction('unfolded', (r.unfolded ? !r.unfolded : true), r)}
                    content={r.sum}
                    readOnly
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'right',
                        paddingRight: 5,
                        fontWeight: 600,
                    }}
                />
            </Row>
        )
    }
    renderChildContent = (r, count, index, row) => {
        let marker1 = '00:00';
        let marker2 = '23:59';

        if (index !== 3) {
            marker1 = row.markers[index]
            marker2 = row.markers[(index + 1 > 2 ? 0 : index + 1)]
        }
        let background = count % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
        return (
            <Row
                key={r.descriptionKey}
            >
                <Cell
                    onChange={(value) => this.updateChildFunction('pos', value, r, row, index, index)}
                    content={r.pos}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateChildFunction('description', value, r, row, index)}
                    content={r.description}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        backgroundColor: background
                    }}
                />
                <Cell
                    onChange={(value) => {
                        if (index !== 3) {
                            this.updateMarkers(index, value, row)
                        }
                    }
                    }
                    content={marker1}
                    onFocusOut={() => {
                        if (marker1.length === 5 && index !== 3) {
                            setTimeout(() => {
                                this.props.recalc()
                            }, 500)
                        }
                    }}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        borderBottom: marker1.length === 5 ? null : '1px solid ' + 'red',
                        ':focus': { borderBottom: marker1.length === 5 ? '1px solid ' + 'white' : '1px solid ' + 'red' },
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => {
                        if (index !== 3) {
                            this.updateMarkers((index + 1 > 2 ? 0 : index + 1), value, row)
                        }
                    }
                    }
                    content={marker2}
                    onFocusOut={() => {
                        if (marker2.length === 5 && index !== 3) {
                            setTimeout(() => {
                                this.props.recalc()
                            }, 500)
                        }
                    }}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        borderBottom: marker2.length === 5 ? null : '1px solid ' + 'red',
                        ':focus': { borderBottom: marker2.length === 5 ? '1px solid ' + 'white' : '1px solid ' + 'red' },
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateChildFunction('hours', value, r, row, index)}
                    content={r.hours.toString().replace('.', ',')}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => {
                        let cal = value.replace(',', '.')
                        this.updateChildFunction('price', cal, r, row, index)
                    }}
                    content={(r.price).toString().replace('.', ',')}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    readOnly
                    content={(parseFloat(r.price.toString().replace(',', '.')) * parseFloat(r.hours.toString().replace(',', '.'))).toFixed(2).replace('.00', '').replace('.', ',')}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'right',
                        paddingRight: 5,
                    }}
                />
            </Row>
        )
    }
    render() {
        let total = 0
        let rows = []
        let count = -1
        for (var key in this.props.rows) {
            if (this.props.rows.hasOwnProperty(key)) {
                count += 1
                const row = this.props.rows[key]
                rows.push(this.renderContent(row, count))
                if (row.unfolded || this.props.open) {
                    row.details.map((d, index) => {
                        rows.push(this.renderChildContent(d, count, index, row))
                    })
                }
                if (row.sum) {
                    total += parseFloat(row.sum.toString().replace(',', '.'))
                }
            }
        }

        return (
            <div style={[{ width: '100%' }]}>
                {this.renderHeader()}
                {rows}
                <div style={{ float: 'right', padding: 5, borderBottom: '1px solid ' + semanticColors.primaryLight }}>
                    <div style={{ fontWeight: 600 }}>
                        I alt: {total.toFixed(2).toString().replace('.00', '').replace('.', ',')}
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    flexify: {
        display: 'flex',
        flexDirection: 'row',
    },
    column: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    }
}

Crew.propTypes = propTypes

Crew.defaultProps = defaultProps

export default Radium(Crew)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Invoice/spreadsheets/crew.js